import React from 'react';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import Grid from "@material-ui/core/Grid";
import makeStyles from "@material-ui/styles/makeStyles";
import MenuItem from "@material-ui/core/MenuItem";
import Menu from "@material-ui/core/Menu";
import MoreVertIcon from '@material-ui/icons/MoreVert';
import IconButton from '@material-ui/core/IconButton';
import Typography from "@material-ui/core/Typography";
import ArrowUpwardIcon from '@material-ui/icons/KeyboardArrowUp';
import ArrowDownwardIcon from '@material-ui/icons/KeyboardArrowDown';
import Button from '@material-ui/core/Button';

const useCardStyles = makeStyles({
    card: {
        minWidth: 275,
    },
    cardActionsContainer: {
        display: 'flex',
        flexDirection: 'column'
    }
});

const Mobile = ({data,onDelete,onEdit,editOrder,moveRow,index}) => {
    const classes = useCardStyles();

    const [anchorEl, setAnchorEl] = React.useState(null);


    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleDelete = () => {
        setAnchorEl(null);
        onDelete();
    };

    const handleEdit = () => {
        setAnchorEl(null);
        onEdit();


    };

    const handleClick = event => {
        setAnchorEl(event.currentTarget);
    };

    return <Grid item>
        <Card className={classes.card}>
            <CardHeader
                action={
                    <IconButton aria-label="settings" onClick={handleClick}>
                        <MoreVertIcon/>
                    </IconButton>
                }
                title={`Name ${data.name}`}
            />
            <CardContent>
                <Grid
                    container
                    justify='space-between'
                    alignItems='flex-end'
                >
                    <Grid item>
                        <Typography variant="h5" component="h2">
                            {data.orderID}
                        </Typography>
                        <Typography color="textSecondary">
                            S. No
                        </Typography>   
                    </Grid>
                <Grid item>
                    <Typography variant="h5" component="h2">
                        {data.shedTypeName}
                    </Typography>
                    <Typography color="textSecondary">
                        Shed Type
                    </Typography>   
                </Grid>
                {editOrder && (
                    <Grid item style={{display: 'flex', gap: '8px'}}>
                        <Button 
                            size="small" 
                            variant="outlined" 
                            onClick={() => moveRow(index, -1)}
                        >
                            <ArrowUpwardIcon />
                        </Button>
                        <Button 
                            size="small" 
                            variant="outlined" 
                            onClick={() => moveRow(index, 1)}
                        >
                            <ArrowDownwardIcon />
                        </Button>
                    </Grid>
                )}
                </Grid>
            </CardContent>
        </Card>
        <Menu
            id="shed-menu"
            anchorEl={anchorEl}
            keepMounted
            open={Boolean(anchorEl)}
            onClose={handleClose}
        >
            <MenuItem onClick={handleEdit}>Edit</MenuItem>
            <MenuItem onClick={handleDelete}>Delete</MenuItem>
        </Menu>
    </Grid>
};

export default Mobile;